var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasNewLeftNavEnabled
        ? _c("new-main-header", { attrs: { "sub-title": _vm.pageSubtitle } }, [
            _vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  "),
          ])
        : _c("main-header", [
            _c(
              "span",
              { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "Back to Start Page",
                      placement: "bottom-start",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "CustomerHistory" } } },
                      [_c("i", { staticClass: "el-icon-back" })]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { attrs: { slot: "page-title" }, slot: "page-title" }, [
              _vm._v(_vm._s(_vm.pageTitle)),
            ]),
            _vm._v(" "),
            _c("span", { attrs: { slot: "sub-title" }, slot: "sub-title" }, [
              _vm._v(_vm._s(_vm.pageSubtitle)),
            ]),
          ]),
      _vm._v(" "),
      _c("main-content", [
        _c(
          "div",
          {
            staticClass: "main-content",
            attrs: { slot: "main-content" },
            slot: "main-content",
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                !_vm.event.ding_id
                  ? _c(
                      "div",
                      [
                        _c("el-alert", [
                          _vm._v(
                            "No event found: " + _vm._s(_vm.$route.params.id)
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.event.ding_id
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          attrs: { slot: "horizontal-menu" },
                          slot: "horizontal-menu",
                        },
                        [
                          false
                            ? _c(
                                "el-menu",
                                {
                                  staticClass: "ring-menu--horizontal",
                                  attrs: {
                                    "default-active": "1",
                                    mode: "horizontal",
                                  },
                                },
                                [
                                  _c(
                                    "el-menu-item",
                                    {
                                      directives: [
                                        {
                                          name: "scroll-to",
                                          rawName: "v-scroll-to",
                                          value: {
                                            el: "#event-details",
                                            container: "#main-content",
                                            duration: 500,
                                            easing: "linear",
                                          },
                                          expression:
                                            "{\n                    el: '#event-details',\n                    container: '#main-content',\n                    duration: 500,\n                    easing: 'linear'}",
                                        },
                                      ],
                                      attrs: { index: "1" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Event Details\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-menu-item",
                                    {
                                      directives: [
                                        {
                                          name: "scroll-to",
                                          rawName: "v-scroll-to",
                                          value: {
                                            el: "#event-bitrate",
                                            container: "#main-content",
                                            duration: 500,
                                            easing: "linear",
                                          },
                                          expression:
                                            "{\n                    el: '#event-bitrate',\n                    container: '#main-content',\n                    duration: 500,\n                    easing: 'linear'}",
                                        },
                                      ],
                                      attrs: { index: "4" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Bitrate Data\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            { attrs: { id: "event-details", gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-card", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix",
                                        attrs: { slot: "header" },
                                        slot: "header",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "header-item" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("common.event")) +
                                                " - " +
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm.event.type
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card-content",
                                        staticStyle: { height: "480px" },
                                      },
                                      [
                                        _c(
                                          "el-row",
                                          { attrs: { gutter: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "event-status",
                                                  },
                                                  [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          content: _vm._f(
                                                            "capitalize"
                                                          )(
                                                            "The event is " +
                                                              _vm.event.metadata
                                                                .status
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-bell",
                                                          class:
                                                            _vm.event.metadata
                                                              .status,
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 22 } },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "event-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Created\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-value",
                                                      },
                                                      [
                                                        _c(
                                                          "time-zone-formatter",
                                                          {
                                                            attrs: {
                                                              "current-time":
                                                                _vm.event
                                                                  .created_at,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "event-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Type\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "capitalize"
                                                              )(_vm.event.type)
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "event-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Favorite\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-value",
                                                      },
                                                      [
                                                        _vm.event.is_favorite
                                                          ? _c("i", {
                                                              staticClass:
                                                                "el-icon-star-on",
                                                              staticStyle: {
                                                                color: "orange",
                                                              },
                                                            })
                                                          : _c("i", {
                                                              staticClass:
                                                                "el-icon-star-off",
                                                              staticStyle: {
                                                                color: "red",
                                                              },
                                                            }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "event-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Metadata\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event-row-value",
                                                      },
                                                      [
                                                        _c(
                                                          "ul",
                                                          _vm._l(
                                                            _vm.event.metadata,
                                                            function (
                                                              value,
                                                              key
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                { key: key },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-row",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "flex-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "capitalize"
                                                                              )(
                                                                                key
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      key ===
                                                                      "duration"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "flex-value",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "b",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      Number(
                                                                                        value
                                                                                      ).toPrecision()
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : key ===
                                                                          "detection_types"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "flex-value",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "b",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.getDetectionTypes(
                                                                                        value
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "flex-value",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "b",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm._f(
                                                                                        "capitalize"
                                                                                      )(
                                                                                        value ||
                                                                                          "No"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("event-device", {
                                    attrs: {
                                      "event-id": _vm.event.ding_id,
                                      "doorbot-id": _vm.event.doorbot_id,
                                      "customer-id":
                                        _vm.$route.params.customer_id,
                                    },
                                    on: {
                                      loaded: function (ref) {
                                        var device = ref.device

                                        return _vm.readDeviceSettings(device)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { id: "event-bitrate", gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c("event-bitrate", {
                                    attrs: { event: _vm.event },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { id: "event-pns", gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c("event-pns", {
                                    attrs: { "event-id": _vm.event.ding_id },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }